import React from 'react';
import { Card, CardBody, CardHeader, Col } from 'reactstrap';
import { H5 } from '../../../AbstractElements';
import ReactApexChart from 'react-apexcharts';

const UserRVOPVDistribution = ({ usersRVOPV = [], loading }) => {
  // Tính toán phân phối user theo các tiêu chí
  const getDistributionData = () => {
    if (!usersRVOPV || usersRVOPV.length === 0) {
      return {
        series: [0, 0, 0, 0],
        labels: ['Active Users', 'Inactive Users', 'With Email', 'Without Email']
      };
    }

    const total = usersRVOPV.length;
    const activeUsers = usersRVOPV.filter(user => user.isActive !== false).length;
    const inactiveUsers = total - activeUsers;
    const withEmail = usersRVOPV.filter(user => user.email && user.email !== '').length;
    const withoutEmail = total - withEmail;

    return {
      series: [activeUsers, inactiveUsers, withEmail, withoutEmail],
      labels: ['Active Users', 'Inactive Users', 'With Email', 'Without Email']
    };
  };

  const distributionData = getDistributionData();

  const chartOptions = {
    chart: {
      type: 'donut',
      height: 350
    },
    labels: distributionData.labels,
    colors: ['#f73164', '#7366ff', '#51bb25', '#ffc107'],
    plotOptions: {
      pie: {
        donut: {
          size: '70%',
          labels: {
            show: true,
            total: {
              show: true,
              label: 'Total Users',
              formatter: () => usersRVOPV.length || 0
            }
          }
        }
      }
    },
    legend: {
      position: 'bottom'
    },
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width: 200
        },
        legend: {
          position: 'bottom'
        }
      }
    }]
  };

  if (loading) {
    return (
      <Col xxl="6" className="box-col-6">
        <Card>
          <CardBody className="d-flex justify-content-center align-items-center" style={{ height: '400px' }}>
            <div className="text-center">
              <p>Đang tải biểu đồ phân phối...</p>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }

  return (
    <Col xxl="6" className="box-col-6">
      <Card>
        <CardHeader className="card-no-border">
          <H5>User Distribution</H5>
        </CardHeader>
        <CardBody>
          <ReactApexChart
            options={chartOptions}
            series={distributionData.series}
            type="donut"
            height={350}
          />
        </CardBody>
      </Card>
    </Col>
  );
};

export default UserRVOPVDistribution;

